// extracted by mini-css-extract-plugin
export var orderSummary = "_tl-0";
export var showMoreLessButton = "_tl-1";